import React, { useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Auth } from 'store/auth/actions';
import { isAuthenicatedSelector, pendingSelector } from 'store/auth/selectors';
import { PasswordResetForm } from './components/PasswordResetForm';

import './style.scss';
import { userApi } from 'helpers/api/user';

const PasswordReset = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isAuthenticated = useSelector(isAuthenicatedSelector);
  const pending = useSelector(pendingSelector);

  useEffect(() => {
    dispatch(Auth.authErrorAction(null));
    dispatch(Auth.getPriceTypesList());
  }, [dispatch]);

  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  const handleLogin = () => {
    history.push('/login');
  };

  const handleSubmit = async ({ email, phoneNumber, smsCode }) => {
    if (Boolean(smsCode)) {
      const {
        data: { token },
      } = await userApi.passwordResetSMS({ phone_number: phoneNumber, code: smsCode });
      history.push(`/recovery-input?key=${token}`);
    } else if (Boolean(email)) {
      const { status } = await userApi.passwordReset({ email });
      if (status == 200) {
        history.push('/check-email-reset');
      }
    }
  };

  return (
    <div className="login-content">
      <PasswordResetForm pending={pending} onSubmit={handleSubmit} />
      <div className="login-footer">
        <div className="login-link" onClick={handleLogin}>
          Вспомнили пароль?
        </div>
      </div>
    </div>
  );
};

export { PasswordReset };
